import { createAction, createDispatchAction } from 'wiloke-react-core/utils';

export const pasteStyleFlow = createAction('@Builder/pasteStyleFlow');

export const usePasteStyleFlow = createDispatchAction(pasteStyleFlow);
